// extracted by mini-css-extract-plugin
module.exports = {"carousel-navigation":"CarouselNavigation_carousel-navigation__10plI","button":"CarouselNavigation_button__d0S2e"};